import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const appTimeStore = defineStore('appTime', () => {
  /**
   * Date representing now - should match when app is booted, so ideally called when
   * app starts or refreshes.
   */
  const now = ref(new Date())

  /**Kicks off app watching current time */
  const watchAppTime = () => {
    /**We're going to continually update now every five seconds or so */
    setInterval(() => (now.value = new Date()), 5000)
  }

  const getNow = computed(() => {
    return now.value
  })

  return {
    now,
    getNow,
    watchAppTime,
  }
})
